import theme from "@/styles/novaTheme";
import { css } from "@emotion/react";

export const footerStyles = css({
  display: "grid",
  width: "100%",
  gridTemplateColumns: "30% 40% 30%",
  backgroundColor: theme.colors.white50,
  padding: "1em 0",
  "> div": {
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "space-evenly"
  },
  "@media (max-width: 1030px)": {
    gridTemplateColumns: "60% 40%",
    "> div:first-of-type": {
      display: "none"
    }
  },
  "@media (max-width: 600px)": {
    gridTemplateColumns: "1fr"
  }
});
